import { Dialog as HeadlessDialog } from '@headlessui/react'
import { ForwardedRef, forwardRef, MutableRefObject, ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

interface CoreDialogProps<InitialFocusElement> {
  title: ReactNode
  children: ReactNode
  className?: string | undefined
  buttons: ReactNode
  onClose: (value: boolean) => void
  open?: boolean
  initialFocus?: MutableRefObject<InitialFocusElement>
}

export const Dialog = forwardRef(
  function Dialog <InitialFocusElement extends HTMLElement | null> (
    { title, children, buttons, className, ...rest }: CoreDialogProps<InitialFocusElement>,
    ref: ForwardedRef<HTMLDivElement>
  ) {
    return (
      <HeadlessDialog
        {...rest}
        ref={ref}
        className={twMerge(
          'core-dialog',
          'typo-body fixed inset-0 z-10 flex min-h-screen w-screen items-center justify-center overflow-y-auto',
          className
        )}
      >
        <HeadlessDialog.Overlay
          className={twMerge(
            'core-dialog-overlay',
            'fixed inset-0 bg-black opacity-75'
          )}
        />

        <div
          className={twMerge(
            'core-dialog-wrapper',
            'z-20 rounded border-2 border-gray-200 bg-white p-6'
          )}
        >
          <HeadlessDialog.Title
            className={twMerge(
              'core-dialog-title',
              'typo-display-small mb-6'
            )}
          >
            {title}
          </HeadlessDialog.Title>

          {children}

          <div className={twMerge(
            'core-dialog-buttons',
            'flex justify-end gap-2 pt-6'
          )}
          >
            {buttons}
          </div>
        </div>
      </HeadlessDialog>
    )
  }
)
